export default {
    //设置路由名称
    ["SET_ROUTER_NAME"](states, params) {
        states.routerName = params;
    },
    //改变loginModal的状态
    ["SET_LOGIN_STATUS"](states, params) {
        states.loginStatus = params;
    },
    //改变userInfo值
    ["SET_USER_INFO"](status, params) {
        status.userInfo = params;
    },
    //改变面包屑得值
    ["SET_BREADCRUMB_LIST"](status, params) {
        status.breadcrumbList = params;
    },
    //设置路由名称
    ["SET_INNER_HEIGHT"](states, params) {
        states.InnerHeight = params;
    },
    //设置全屏状态
    ["SET_FULL_STATUS"](states, params) {
        states.FullStatus = params;
    },
}



// WEBPACK FOOTER //
// ./src/store/navigation/mutations.js